import { UntypedFormGroup } from "@angular/forms";
import { ReimbursementRequest } from "./reimbursement-request";

export class ReimbursementFormMapper {

    public static mapClaimRequest(form: UntypedFormGroup): ReimbursementRequest {
        if (form) {
            let claimForm = form.value;
            let claimRequest: ReimbursementRequest = new ReimbursementRequest();

            claimRequest.contractNumber = claimForm.contractNumber;
            claimRequest.firstName = claimForm.firstName;
            claimRequest.lastName = claimForm.lastName;

            claimRequest.phoneNumber = claimForm.phoneNumber;
            claimRequest.reimbursementType = claimForm.reimbursementType;

            claimRequest.addressLine1 = claimForm.streetAddress1;
            claimRequest.addressLine2 = claimForm.streetAddress2;
            claimRequest.state = claimForm.state;
            claimRequest.city = claimForm.city;
            claimRequest.zip = claimForm.zip;
           
            return claimRequest;
        }
        else {
            return null;
        }
    }
}